import { Charge, Quotation } from '@/types/types'

export const mapBookingChargeToQuotation = (charge: Charge): Quotation => {
  return {
    id: charge.quotation_id,
    amount: charge.amount,
    currency: charge.currency
  }
}
